import axios from "../utils/axios";

/**
 * List all categories with pagination and advanced filtering
 * @param {Object} params - Query parameters (page, per_page, search, is_active, department_id, parent_id)
 * @returns {Promise} Categories list
 */
export const getCategories = async (params) => {
    try {
        const { data } = await axios.get('/admin/categories', { params });
        return data;
    } catch (error) {
        console.error("🚀 ~ getCategories ~ error:", error);
        throw error;
    }
};

/**
 * Get a single category by ID (includes breadcrumbs)
 * @param {number|string} id - Category ID
 * @returns {Promise} Category data
 */
export const getCategoryById = async (id) => {
    try {
        const { data } = await axios.get(`/admin/categories/${id}`);
        return data;
    } catch (error) {
        console.error("🚀 ~ getCategoryById ~ error:", error);
        throw error;
    }
};

/**
 * Create a new category
 * @param {Object} categoryData - Category data
 * @returns {Promise} Created category
 */
export const createCategory = async (categoryData) => {
    try {
        const { data } = await axios.post('/admin/categories', categoryData);
        return data;
    } catch (error) {
        console.error("🚀 ~ createCategory ~ error:", error);
        throw error;
    }
};

/**
 * Update an existing category
 * @param {number|string} id - Category ID
 * @param {Object} categoryData - Updated category data
 * @returns {Promise} Updated category
 */
export const updateCategory = async (id, categoryData) => {
    try {
        const { data } = await axios.put(`/admin/categories/${id}`, categoryData);
        return data;
    } catch (error) {
        console.error("🚀 ~ updateCategory ~ error:", error);
        throw error;
    }
};

/**
 * Soft delete a category
 * @param {number|string} id - Category ID
 * @returns {Promise} Result of deletion
 */
export const deleteCategory = async (id) => {
    try {
        const { data } = await axios.delete(`/admin/categories/${id}`);
        return data;
    } catch (error) {
        console.error("🚀 ~ deleteCategory ~ error:", error);
        throw error;
    }
};

/**
 * Move a category to a new parent
 * @param {number|string} id - Category ID to move
 * @param {number|string|null} parent_id - New parent category ID
 * @returns {Promise} Moved category data
 */
export const moveCategory = async (id, parent_id) => {
    try {
        const { data } = await axios.post(`/admin/categories/${id}/move`, { parent_id });
        return data;
    } catch (error) {
        console.error("🚀 ~ moveCategory ~ error:", error);
        throw error;
    }
};

/**
 * Get categories for selection (simplified list)
 * Usually used for Parent Category dropdown
 * @param {Object} params - optional filters (e.g. department_id)
 * @returns {Promise} List for dropdown
 */
export const getCategoriesForSelect = async (params) => {
    try {
        // We use the same getCategories but with per_page: -1 or large number if API supports it
        // Or a dedicated endpoint if exists. For now, we use standard listing with filters.
        const { data } = await axios.get('/admin/categories', {
            params: { ...params, per_page: 100 }
        });
        return data;
    } catch (error) {
        console.error("🚀 ~ getCategoriesForSelect ~ error:", error);
        throw error;
    }
};
